import { Divider, Select, Button, Spin } from 'antd';

interface SingleSelectProps {
    field: {
        value: { label: string; value: string } | null;
        onChange: (val: { label: string; value: string } | null) => void;
    };
    options: { label: string; value: string }[];
    hasMore?: boolean;
    loading: boolean;
    placeholder: string;
    allowClear?: boolean;
    disabled?: boolean;
    size?: 'small' | 'middle' | 'large';
    filterOption?: boolean;
    loadMore?: () => void;
    onClear?: () => void;
    onSearch?: (val: string) => void;
}

export const SingleSelect = ({
    field,
    options,
    hasMore,
    loading,
    placeholder,
    allowClear,
    disabled,
    size,
    filterOption = false,
    loadMore,
    onClear,
    onSearch,
}: SingleSelectProps) => {
    const { value, onChange } = field;

    return (
        <Select
            labelInValue
            size={size || 'large'}
            options={options}
            defaultValue={null}
            value={value ?? undefined}
            onChange={(val) => onChange(val)}
            placeholder={placeholder}
            loading={loading}
            disabled={(loading && options.length === 0) || disabled}
            style={{ width: '100%' }}
            allowClear={allowClear}
            filterOption={
                filterOption
                    ? (input, option) => {
                          const optionLabel =
                              option?.label ?? (option as any)?.children ?? '';
                          return optionLabel
                              .toString()
                              .toLowerCase()
                              .includes(input.toLowerCase());
                      }
                    : false
            }
            showSearch
            onSearch={onSearch}
            onClear={() => {
                onChange(null);
                onClear?.();
            }}
            dropdownRender={(menu) => (
                <>
                    {menu}
                    <Divider style={{ margin: '4px 0' }} />
                    {hasMore && (
                        <div
                            style={{ padding: 8, textAlign: 'center' }}
                            onMouseDown={(e) => e.preventDefault()}
                        >
                            <Button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    loadMore?.();
                                }}
                                disabled={loading || !hasMore}
                                block
                            >
                                {loading ? (
                                    <Spin size="small" />
                                ) : hasMore ? (
                                    'Load more'
                                ) : (
                                    'No more data'
                                )}
                            </Button>
                        </div>
                    )}
                </>
            )}
        />
    );
};
